import { useState } from 'react';

function Success() {
  const [copied, setCopied] = useState(false);
  return (
    <section className="depth-panel mx-auto mt-10 flex max-w-xl flex-col items-center rounded-3xl p-8 text-center sm:p-10">
      <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-cobalt">
        Connection complete
      </p>
      <h1 className="mb-4 mt-3 text-3xl font-black tracking-[-0.04em] text-gray-900">
        You're connected
      </h1>
      <p className="mb-6 text-center leading-6 text-gray-600">
         Your activity account is connected to RaceTrainer. New workouts will sync automatically.
      </p>
      {!copied ? (
        <button
          onClick={() => {
            const message =
              'I just joined RaceTrainer.ai! Check it out: https://racetrainer.ai';
            navigator.clipboard.writeText(message);
            setCopied(true);
          }}
          className="inline-block rounded-full bg-brand-midnight px-6 py-3 font-bold text-white transition-colors hover:bg-brand-slate dark:bg-white dark:text-brand-midnight dark:hover:bg-gray-100"
        >
          Share
        </button>
      ) : (
        <p
          id="inviteMessage"
          className="rounded-full bg-brand-voltSoft px-5 py-3 text-center font-semibold text-brand-midnight"
        >
          Link copied to clipboard!
        </p>
      )}
    </section>
  );
}

export default Success;
